import React from 'react';
import { CustomizedTypography } from '@components/Customized';
import { WithdrwalStage } from './useWithdrawalStage';
import useStyles from './useStyles';
import AccountHeader from '../AccountHeader';

interface Props {
  matches: boolean;
  stage: WithdrwalStage;
  isConnect: boolean;
  totalCount: number;
  connectGroupCount: number;
}

const MemberShipWithdrawalPresenter: React.FC<Props> = ({
  children,
  matches,
  isConnect,
  totalCount,
  connectGroupCount,
  stage
}) => {
  const classes = useStyles();

  return (
    <div className={classes['Member-Withdrawal-root']}>
      {matches && <AccountHeader title={'계정 설정'} onClickBack={undefined} />}
      <div className="authenticate">
        <CustomizedTypography
          variant={matches ? 'h3' : 'h2'}
          color="textPrimary"
          fontWeight="500"
          gutterBottoms={matches ? 20 : 36}
        >
          회원 탈퇴
        </CustomizedTypography>
        <CustomizedTypography
          variant={'h4'}
          color="textPrimary"
          fontWeight="500"
          gutterBottoms={matches ? 24 : 60}
        >
          {stage === 'confirm-password' &&
            '회원님의 개인정보를 보호하기 위해 비밀번호를 다시 한 번 확인합니다'}
          {stage === 'confirm-membership' &&
            '탈퇴하시려는 이유를 알려주세요. 제품 개선 자료로 활용하겠습니다.'}

          {stage === 'confirm-chat' &&
            (isConnect ? (
              <>
                캐파에서 상담 중인 채팅이{' '}
                <span className="emphasis">{totalCount}</span>개, 캐파
                커넥트에서 소유자인 그룹이{' '}
                <span className="emphasis">{connectGroupCount}</span>개
                있습니다. 탈퇴 후 종료될 상담과 삭제될 그룹을 확인한 후
                진행하세요.
              </>
            ) : (
              <>
                현재 상담 중인 채팅이{' '}
                <span className="emphasis">{totalCount}</span>개 있습니다. 탈퇴
                후 종료될 상담을 확인한 후 진행하세요.
              </>
            ))}
        </CustomizedTypography>
      </div>
      {children}
    </div>
  );
};

export default MemberShipWithdrawalPresenter;
